import { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import avatar from "../../../Assets/img/patient.png";
import { CONFIGS, MODULES } from "../../../Constants/appConstants";
import * as storageConstants from "../../../Constants/storageConstant";
import { NO_MOBILE_NUMBER } from "../../../Constants/stringConstants";
import { IMAGE_URL } from "../../../Constants/urlConstants";
import * as commonServices from "../../../Services/common";
import { changeDateFormatForDisplay } from "../../../Utils/dateUtils";
import canAccessModule from "../../../Utils/permissionUtils";
import { slice } from "../../../Utils/stringUtils";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import ImageResource from "../../../Wrapper/ImageResource/ImageResource";
import Button from "../../_widgets/Button/Button";
import DateRangePicker from "../../_widgets/DateRangePicker/DateRangePicker";
import Dropdown from "../../_widgets/Dropdown/Dropdown";
import Input from "../../_widgets/Input/Input";
import MainLoader from "../../_widgets/Loader/MainLoader";
import NavBar from "../../_widgets/NavBar/NavBar";
import CustomPagination from "../../_widgets/Pagination/Pagination";
import Text from "../../_widgets/Text/Text";
import CustomTooltip from "../../_widgets/Tooltip/CustomTooltip";
import AnimatedPage from "../../AnimatedPage/AnimatedPage";
import "./../Patients.scss";

const TrackPatientUI = ({
  startRange,
  endRange,
  setStartRange,
  setEndRange,
  activeStatus,
  setActiveStatus,
  openDetailsPage,
  loading,
  patientsList,
  getPatientsList,
  selectedMedicines,
  setSelectedMedicines,
  selectedServices,
  setSelectedServices,
  selectedGender,
  setSelectedGender,
  selectedCity,
  setSelectedCity,
  selectedDiagnosis,
  setSelectedDiagnosis,
  selectedDoctor,
  setSelectedDoctor,
  ageRange,
  setAgeRange,
  allDiagnosis,
  onPageChange,
}) => {
  const [checkRequired, setCheckRequired] = useState({
    aadhar_no: false,
    mno: false,
    file_no: false,
    online_id: false,
  });

  useEffect(() => {
    let configData = commonServices.getLocalData(storageConstants.CONFIG);
    let data = {
      aadhar_no: false,
      mno: false,
      file_no: false,
      online_id: false,
      city: false,
      address: false,
    };
    configData?.forEach((config) => {
      if (config.key === CONFIGS.AADHAR_NO && config.mandatory === "true" && config.show === "true")
        data.aadhar_no = true;
      if (config.key === "mobile_no" && config.mandatory === "true" && config.show === "true")
        data.mno = true;
      if (config.key === CONFIGS.FILE_NO && config.mandatory === "true" && config.show === "true")
        data.file_no = true;
      if (config.key === CONFIGS.ONLINE_ID && config.mandatory === "true" && config.show === "true")
        data.online_id = true;
      if (config.key === CONFIGS.ADDRESS && config.mandatory === "true" && config.show === "true")
        data.address = true;
      if (config.key === CONFIGS.CITY && config.mandatory === "true" && config.show === "true")
        data.city = true;
    });
    setCheckRequired(data);
  }, []);

  return (
    <div className="track_patient">
      <AnimatedPage>
        <NavBar
          buttonIconsuff={"adduser"}
          heading={"Track Patient"}
          onClick={() => {
            document.body.classList.toggle("side_active");
            document.body.classList.toggle("side_active_mb");
          }}
          Icon="menu"
        />

        <div className="patient_list white_card">
          <div className="top_bar">
            <Row className="gx-2 mt-3">
              <Col md={6} className="mb-4">
                <label>Start Range</label>
                <DateRangePicker
                  startDate={startRange?.startDate}
                  endDate={startRange?.endDate}
                  setStartDate={(startDate) => setStartRange({ ...startRange, startDate })}
                  setEndDate={(endDate) => setStartRange({ ...startRange, endDate })}
                  allowFutureDates={true}
                />
              </Col>
              <Col md={6} className="mb-4">
                <label>End Range</label>
                <DateRangePicker
                  startDate={endRange?.startDate}
                  endDate={endRange?.endDate}
                  setStartDate={(startDate) => setEndRange({ ...endRange, startDate })}
                  setEndDate={(endDate) => setEndRange({ ...endRange, endDate })}
                  allowFutureDates={true}
                />
              </Col>
              {canAccessModule(MODULES.MEDICINES_MODULE) && (
                <Col md={6} className="mb-2">
                  <Dropdown
                    isMulti
                    label="Medicine(s)"
                    placeholder="Medicine"
                    name={selectedMedicines}
                    onChange={setSelectedMedicines}
                    options={commonServices.getMedicineOptions()}
                  />
                </Col>
              )}
              {canAccessModule(MODULES.SERVICIES_MODULE) && (
                <Col md={6} className="mb-2">
                  <Dropdown
                    isMulti
                    label="Service(s)"
                    placeholder="Service"
                    name={selectedServices}
                    onChange={setSelectedServices}
                    options={commonServices.getServiceOptions()}
                  />
                </Col>
              )}
              <Col md={6}>
                <Dropdown
                  isMulti={true}
                  label="Gender"
                  placeholder="Gender"
                  name={selectedGender}
                  onChange={setSelectedGender}
                  options={commonServices.getGenderOptions()}
                />
              </Col>
              {commonServices.isConfigEnable(CONFIGS.CITY)[0] && (
                <Col md={6}>
                  <Dropdown
                    isMulti={true}
                    label="City"
                    placeholder="City"
                    name={selectedCity}
                    onChange={setSelectedCity}
                    options={commonServices.getCityOptions()}
                  />
                </Col>
              )}
              {canAccessModule(MODULES.DIAGNOSIS) && (
                <Col md={6}>
                  <Dropdown
                    isMulti
                    label="Diagnosis"
                    placeholder="Diagnosis"
                    name={selectedDiagnosis}
                    onChange={setSelectedDiagnosis}
                    options={commonServices.getDiagnosisOptions(allDiagnosis)}
                  />
                </Col>
              )}
              <Col md={6}>
                <Dropdown
                  isMulti
                  label="Doctor"
                  placeholder="Doctor"
                  name={selectedDoctor}
                  onChange={setSelectedDoctor}
                  options={commonServices.getDoctorOptions()}
                />
              </Col>

              <Col md={6}>
                <div className="d-flex flex-column">
                  <label className="mb-1">Age Range</label>
                  <div className="d-flex align-items-center gap-2">
                    <Input
                      placeholder="From"
                      value={ageRange.from}
                      onChange={(e) =>
                        setAgeRange((prev) => ({
                          ...prev,
                          from: e.target.value,
                        }))
                      }
                    />
                    <span>to</span>
                    <Input
                      placeholder="To"
                      value={ageRange.to}
                      onChange={(e) => setAgeRange((prev) => ({ ...prev, to: e.target.value }))}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="gx-2 mt-3">
              <Col md={12} className="mb-2">
                <label>Status</label>
                <div className="d-flex gap-4 flex-wrap">
                  {["Regular", "Non-Regular", "Re-Active", "LastVisitedIn", "Followup"].map(
                    (status) => (
                      <label key={status} className="d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="status"
                          checked={activeStatus === status}
                          onChange={() => setActiveStatus(status)}
                        />
                        {status === "Followup"
                          ? "Followup/Next Visit On"
                          : status.replace(/([A-Z])/g, " $1")}
                      </label>
                    ),
                  )}
                </div>
              </Col>
            </Row>
            <Row className="gx-2 mb-3 mt-3">
              <Col md={1} className="d-flex align-items-end">
                <Button
                  buttonType="primary"
                  onClick={() => getPatientsList(1)}
                  text="Search"
                  isLoading={loading}
                />
              </Col>
            </Row>
          </div>

          <div className="custom_table position-relative">
            {loading ? (
              <MainLoader />
            ) : patientsList?.data?.length > 0 ? (
              <>
                <AnimatedPage>
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>Patient Name</th>
                        <th>Info</th>
                        <th>Address</th>
                        <th>Item(s)</th>
                        <th>Last visit date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {patientsList?.data?.map((data) => (
                        <tr key={data.id} onClick={() => openDetailsPage(data.id)}>
                          <td>
                            <div className="patient_name">
                              <div className="profile_picture d-flex">
                                <div className="position-relative d-flex align-items-center">
                                  {/* Profile Image */}
                                  <img
                                    src={
                                      data?.patient?.photo_url
                                        ? IMAGE_URL + data?.patient?.photo_url
                                        : avatar
                                    }
                                    onError={(event) => commonServices.handleImageError(event)}
                                    alt="Patient Photo"
                                    className="rounded-circle"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      objectFit: "cover",
                                    }}
                                  />

                                  {/* WhatsApp Icon Overlay */}
                                  <div
                                    className={`position-absolute ${data.mno === null && "reduce_opacity"} `}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();

                                      if (data?.mno) {
                                        window.open(
                                          commonServices.createWhatsAppLink(data?.mno, data?.name),
                                        );
                                      }
                                    }}
                                    style={{
                                      bottom: "-2px",
                                      cursor: "pointer",
                                      right: "-5px",
                                      backgroundColor: "white",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <CustomTooltip
                                      text={data?.mno === null && NO_MOBILE_NUMBER}
                                      type="tooltip"
                                      placement="top"
                                    >
                                      <IconResource type="whatsapp" size={16} />
                                    </CustomTooltip>
                                  </div>
                                </div>
                              </div>
                              <div className="name_id">
                                <CustomTooltip
                                  type="tooltip"
                                  text={data?.patient?.name?.toUpperCase()}
                                >
                                  {slice(data?.patient?.name?.toUpperCase() || "-", 10)}
                                </CustomTooltip>
                                <Text
                                  type="small"
                                  text={commonServices.getPatientIdentifier(data?.id, data)}
                                />
                              </div>
                            </div>
                          </td>
                          {checkRequired.aadhar_no ? (
                            <td>{data?.patient?.aadhar_no || "-"}</td>
                          ) : checkRequired.mno ? (
                            <td>M. No.: {data?.patient?.mno || "-"}</td>
                          ) : checkRequired.file_no ? (
                            <td>{data?.patient?.file_no || "-"}</td>
                          ) : (
                            <td>{data?.patient?.online_id?.toUpperCase() || "-"}</td>
                          )}
                          <td>{data?.patient?.address || "-"}</td>
                          <td>
                            {data?.orders[0] !== undefined && data?.orders[0].products.length > 0
                              ? data?.orders[0].products
                                  .map((product) => product.item_detail?.name)
                                  .filter(Boolean) // Remove undefined/null if any
                                  .join(", ")
                              : "-"}
                          </td>
                          <td>
                            {data?.visit_date ? changeDateFormatForDisplay(data?.visit_date) : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </AnimatedPage>
                <CustomPagination
                  totalData={patientsList?.total}
                  pageLength={patientsList?.per_page}
                  activePage={patientsList?.current_page}
                  onPageChange={onPageChange}
                  lastPage={patientsList.last_page}
                />
              </>
            ) : (
              <div className="no_data text-center">
                <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                <Text type="h2" text="There is no data to display. Try re-setting filters!" />
              </div>
            )}
          </div>
        </div>
      </AnimatedPage>
    </div>
  );
};

export default TrackPatientUI;
